const initialSetup = {
  getModulesInfo: `/module/`,
  addModuleFocusOn: (childId) => `/child/${childId}/setModuleFocusOn/`,
  addInitialSetup: (childId) => `/child/${childId}/setInitialSetup/`,
  disableFirstTime: `/user_info/first_time/`,
};

export { initialSetup };
